import React from "react";

import { CheckoutApp } from "../../apps/checkout/CheckoutApp";

import styles from "./index.module.scss";

/**
 * The `#checkout-app` mount point of the checkout document. The checkout app
 * lives in the document's React tree (mounted client-side by CheckoutApp; the
 * dependency tree is not SSR-safe).
 */
export const CheckoutPageBody = (): React.JSX.Element => (
    <div className="l-capped-width">
        <div id="checkout-app" className={styles.checkoutAppContainer}>
            <CheckoutApp />
        </div>
    </div>
);
